/* eslint-disable */
export function batchActions(...actions: any /* actions must be of type any for generic purpose */): Record<string, any> {
  /* eslint-enable */
  return {
    type: 'BATCH_ACTIONS',
    actions: actions
  };
}
